import React from 'react';

import IconBack from '../../../assets/icon_back_circle_purple.svg';

const StepperGen = ({
  currentStep,
  totalSteps,
  onBackClick,
  barPercentage,
  stepperText,
}) => {
  return (
    <div className="stepperGen">
      <img
        className="stepperGen__icon"
        src={IconBack}
        alt="icono atrás"
        onClick={onBackClick}
      />
      <p className="stepperGen__text">
        {stepperText ? stepperText : `PASO ${currentStep} DE ${totalSteps}`}
      </p>
      <div className="stepperGen__progress">
        <div
          className="bar"
          style={{ transform: `scaleX(${barPercentage})` }}
        ></div>
      </div>
    </div>
  );
};

export default StepperGen;
